import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  data: () => ({
    sum: 0,
    options: {
      responsive: true,
      legend: {
        position: 'bottom',
        onHover: function(e) {
          e.target.style.cursor = 'pointer';
        }
      },
      title: {
        display: false,
        position: 'top',
        text: 'Recruiting Costs'
      },
      tooltips: {
        backgroundColor: 'white',
        bodyFontColor: '#00095b',
        bodyFontFamily:'FordAntenna-Regular',
        bodyFontSize: 16,
        borderWidth: '1',
        borderColor: '#6E6E6E',
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data) {
            // const corporation = data.datasets[tooltipItem.datasetIndex].label;
            const valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            let total = data.datasets[0].data.reduce((a, b) => a + b, 0);

            for (let i = 0; i < data.datasets.length; i++) {
              return ["$" + valor.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  }), "Total : $"  + total.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0  })];
            }

          }
        }
      },
    }
  }),
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}
